/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React from 'react'
import './CserviceTypeSummary.scss'
import { CardBody, Card, CardHeader, Container } from 'reactstrap'
import { Fragment } from 'react'
import { InsuranceBenefitsComponent } from '../InsuranceBenefits/InsuranceBenefits'
import { ICoverageDiscoveryResponseStateManager, IBaseSection } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'
import { ServiceTypeHelper } from '../../../../utils/ServiceTypeHelper'
import { renderToString } from 'react-dom/server'

export interface ICServiceTypeSummaryProps {
	CoverageDiscoveryResponseStateManager: ICoverageDiscoveryResponseStateManager
}

export class CserviceTypeSummary extends React.Component<ICServiceTypeSummaryProps> {
	renderCServiceTypeSummarydata = (val: IBaseSection): JSX.Element[] => {
		return ServiceTypeHelper.getCommercialSTC(val).map((res, index) => {
			return (
				<Fragment key={index}>
					<tbody key={index} className="summaryBody">
						<tr className="summarySection">
							<td colSpan={3}>
								<h4>
									{res.serviceCodeDescription}&nbsp;({res.serviceCode})
								</h4>
							</td>
							<td className="summaryHide">
								<input type="hidden" value={res.serviceCode} />
							</td>
						</tr>
					</tbody>
					{res.insurances &&
						res.insurances.map((insurance, index) => {
							const insBenefits: JSX.Element = <InsuranceBenefitsComponent key={index} data={insurance} CoverageDiscoveryResponseStateManager={this.props.CoverageDiscoveryResponseStateManager} />
							const stringElement = renderToString(insBenefits)
							if (insBenefits && stringElement && stringElement.trim() !== '') {
								return (
									<tbody key={index} className={'summaryBody summaryBody' + insurance.code}>
										{insBenefits}
									</tbody>
								)
							}
						})}
				</Fragment>
			)
		})
	}

	render(): React.ReactNode {
		const cServiceTypeSection = this.props.CoverageDiscoveryResponseStateManager.selectedCServiceTypeSection
		if (cServiceTypeSection) {
			return (
				<div>
					<div className="accordion-group service-coverage">
						<div id={cServiceTypeSection.id} className="section" data-loadorder={cServiceTypeSection.loadOrder} data-index={cServiceTypeSection.summary.index}>
							<Card style={{ marginBottom: '1rem' }} className="card" key={cServiceTypeSection.displayOrder}>
								<CardHeader data-event={cServiceTypeSection.displayOrder} className="service-coverage accordion-heading whiteText">
									{cServiceTypeSection.summary.title}
								</CardHeader>
								<CardBody className="card-body">
									<Container style={{ margin: 0, padding: 0, width: '100%' }}>
										<div className="cdResponsePage">
											<table className="service-types-table">
												<tbody>
													<tr className="summaryDisplaying">
														<td colSpan={4}>
															Displaying {cServiceTypeSection.summary.selectedSections.length} of {cServiceTypeSection.summary.sections.length} sections
														</td>
													</tr>
												</tbody>
												{this.renderCServiceTypeSummarydata(cServiceTypeSection)}
											</table>
										</div>
									</Container>
								</CardBody>
							</Card>
						</div>
					</div>
				</div>
			)
		} else {
			return <></>
		}
	}
}
